import {
  AuthenticationResult,
  EventMessage,
  EventType,
  PublicClientApplication,
} from "@azure/msal-browser";
import { loginRequest, MsalConfig } from "./AuthConfig";

export const MsalInstance = new PublicClientApplication(MsalConfig);

const pendingRedirectKey = "pending-redirect";

MsalInstance.handleRedirectPromise()
  .then(handleResponse)
  .catch((err) => {
    console.error(err);
  });

function savePendingRedirect(): void {
  window.localStorage.setItem(pendingRedirectKey, window.location.href);
}

function attemptLogin(): void {
  savePendingRedirect();
  MsalInstance.loginRedirect({
    ...loginRequest,
  });
}

function redirectAfterLogin() {
  const href = window.localStorage.getItem(pendingRedirectKey);
  if (href) {
    localStorage.removeItem(pendingRedirectKey);
    window.location.href = href;
  }
}

function handleResponse(resp: any) {
  if (resp !== null) {
    MsalInstance.setActiveAccount(resp.account);
    redirectAfterLogin();
  } else {
    const currentAccounts = MsalInstance.getAllAccounts();
    if (!currentAccounts || currentAccounts.length < 1) {
      attemptLogin();
    } else if (currentAccounts.length === 1) {
      const activeAccount = currentAccounts[0];
      MsalInstance.setActiveAccount(activeAccount);
      redirectAfterLogin();
    }
  }
}

MsalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const { account } = payload;
    MsalInstance.setActiveAccount(account);
  }
});
